/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 40px 10px 60px;
  display: grid;
  grid-template-columns: 26vw 26vw 26vw;
  grid-row-gap: 30px;
  grid-column-gap: 30px;

  /* padding-bottom: 640px; */

  width: 100%;

  @media (max-width: 1200px) {
    display: grid;
    grid-template-columns: 26vw 26vw;
  }
`;

export const Card = styled.button`
  background: none;
  border: 1px solid #000;
  border-radius: 10px;

  /* flex-direction: column; */

  span {
    img {
      width: 100%;
      height: 180px;
      object-fit: cover;

      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }

  div.content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: top;

    padding: 10px;

    height: 75px;
  }

  div.title {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    width: 65%;
    height: 80px;

    p {
    }
  }

  div.detail {
    width: 35%;
    height: 80px;

    div.icon {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      width: 110%;
      height: 25px;

      p {
        font-size: 12px;
        font-weight: bold;
        margin-left: 5px;
      }
    }
  }

  div {
    height: 10vh;
    background: #fff;

    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */

    padding: 10px;

    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
`;

export const ContainerFailed = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  button {
    background: rgba(0, 0, 0, 0);
    width: 150px;
    padding: 10px;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 600px;
  }
`;

export const ViewToolTip = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 400px;
  height: 300px;
  margin-left: 20px;
  margin-top: -20px;
  padding: 10px;

  background: #090f35;
  border: 3px solid #36ded6;
  border-radius: 5px;
  color: #fff;

  p {
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: center;
    font-size: 16px;
  }

  &::before {
    content: '';
    position: absolute;
    /* right: 12px; */
    left: 5px;
    top: -3px;
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-right: 15px solid #36ded6;
  }
`;
